// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'user-female-solid';

export const Component = () => (
  <g fill='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path stroke='currentColor' d='M15.712 16.969a7.425 7.425 0 0 0-13.424 0' />
    <path d='M9.315.54a6.344 6.344 0 0 1 6.03 6.335v1.47l.013.272c.027.27.096.536.203.787l.975 2.274.053.143a1.566 1.566 0 0 1-.847 1.9l-.006.003a10.84 10.84 0 0 1-1.61.552l-.062.016h-1.357l-.13-.095-.006-.005-.036-.023a5.149 5.149 0 0 0-.84-.41c-.605-.231-1.513-.467-2.695-.467a8.108 8.108 0 0 0-2.766.47 6.095 6.095 0 0 0-.73.317 3.37 3.37 0 0 0-.178.1c-.02.01-.033.019-.041.024l-.008.006-.125.083H3.937l-.062-.016a10.827 10.827 0 0 1-1.61-.552l-.006-.003a1.563 1.563 0 0 1-.794-2.043l.974-2.274a2.68 2.68 0 0 0 .204-.787l.014-.271V6.875A6.343 6.343 0 0 1 9 .531zM9 3.718a.5.5 0 0 0-.5.5 3.22 3.22 0 0 1-3.218 3.218.5.5 0 0 0-.5.5 4.22 4.22 0 1 0 8.437 0 .5.5 0 0 0-.5-.5A3.22 3.22 0 0 1 9.5 4.22a.5.5 0 0 0-.5-.5z' />
  </g>
);

export const viewBox = '0 0 18 18';
